(function() {
    'use strict';
    angular
        .module('emarket.main.category')
        .factory('Category', ['$http', 'PATH', 'restmod', '$mdDialog', function($http, PATH, restmod, $mdDialog) {
            var category = restmod.model('/categories').mix({
                $extend: {
                    Model: {
                        getAncestor: function(id) {
                            return this.$find('parent/' + id);
                        }
                    },
                    List: {
                        getTree: function(category) {
                            return this.$asList(function(categories) {
                                return categories
                                    .filter(function(cat) {
                                        return (
                                            cat.lft <= category.lft &&
                      cat.rgt >= category.rgt &&
                      category._id !== cat._id
                                        );
                                    })
                                    .sort(function(a, b) {
                                        return b.rgt - b.lft - (a.rgt - a.lft);
                                    });
                            });
                        }
                    }
                }
            });
            category.openCategoryChooser = function() {
                var promise = $mdDialog.show({
                    controller: 'CategoryDialogController as model',
                    templateUrl: 'main/category/dialog/category-dialog.tpl.html'
                });
                return promise;
            };
            category.getFields = function(id) {
                var url = PATH.api + '/categories/fields/' + id;
                return $http.get(url).then(function(response) {
                    return response.data;
                });
            };
            return category;
        }]);
}());
